import { PeriodTypes } from './constants';
import { Values } from './objectEnums';

const getLastDeclaredPeriod = <T extends { periodType: Values<typeof PeriodTypes> }>(
	schedule: T[],
): T | null => {
	const declaredPeriods = schedule.filter((s) => s.periodType === PeriodTypes.DECLARED);

	return declaredPeriods[declaredPeriods.length - 1] ?? null;
};

export default getLastDeclaredPeriod;
